import React from 'react';
import {
  Form,
  Modal,
  Loading,
  TextInput,
  Select,
  SelectItem,
} from 'carbon-components-react';

import './login.styles.scss';
import useSWRMutation from 'swr/mutation';
import CustomButton from '../../../components/custom-button/custom-btn.component';
import { useReducerSpread } from '../../../utils/common.util';
import { postMethod } from '../../../api/common';
import { usePaystackPayment } from 'react-paystack';

const initialData = {
  amount: '',
  invoiceNumber: '',
  emailAddress: '',
  paymentMethod: '',
};

export default function PaySubscriptionModal({ isOpen, closeModal }) {
  const [formData, setFormData] = useReducerSpread(initialData);

  const { trigger, isMutating, data, error } = useSWRMutation(
    `school/verify-invoice-number`,
    (url) => postMethod(url, formData),
    { throwOnError: false },
  );

  const config = {
    reference: new Date().getTime().toString(),
    email: formData.emailAddress,
    amount: Number(formData.amount) * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
    // publicKey: 'pk_test_164f95b440d8dd1fde4600cd92363bd821f203e8',
    publicKey: 'pk_live_2b5bafbc8ddd901135effedd422b0477b661556e',
    currency: 'GHS',
    subaccount: 'ACCT_cfblco26pa6lj02',
    channels: [formData.paymentMethod.toLowerCase()],
    metadata: {
      custom_fields: [
        {
          display_name: 'invoice_number',
          variable_name: 'invoice_number',
          value: formData.invoiceNumber,
        },
      ],
    },
  };
  const initializePayment = usePaystackPayment(config);
  const onSuccess = (reference) => {
    reset();
    window.location.reload();
  };
  const onClose = () => {};

  function makePayment() {
    initializePayment((reference) => {
      onSuccess(reference);
      onClose();
    });
  }

  function reset() {
    setFormData(initialData);
    closeModal();
  }

  return (
    <Modal
      id="pay-subscription-modal"
      className="pay-subscription-modal"
      hasScrollingContent
      passiveModal={true}
      open={isOpen}
      modalHeading="Pay Subscription"
      primaryButtonDisabled={false}>
      <Form action="post">
        <p className="text-14 mt-10">
          {data
            ? `A one-week grace period will be granted for partial payments. After
            this period, access to the system will be suspended until full
            payment is received.`
            : `Verify invoice number and email address`}
        </p>
        <div className="f-width mt-20">
          <div>
            {!data && (
              <>
                <div className="mt-20">
                  <TextInput
                    id="email"
                    name="email"
                    type="email"
                    labelText="Email Address"
                    placeholder="Enter email address"
                    value={formData.emailAddress}
                    onChange={(e) =>
                      setFormData({ emailAddress: e.target.value })
                    }
                  />
                </div>
                <div className="mt-20">
                  <TextInput
                    id="invoiceNumber"
                    name="invoiceNumber"
                    labelText="Invoice Number"
                    placeholder="Enter Invoice Number"
                    value={formData.invoiceNumber}
                    onChange={(e) =>
                      setFormData({ invoiceNumber: e.target.value })
                    }
                  />
                </div>
              </>
            )}

            {data && (
              <p className="text-40 mt-20 text-danger">
                Balance due: GH₵{data?.data?.invoice?.balance_due}
              </p>
            )}

            {data && (
              <>
                <div className="mt-20">
                  <TextInput
                    id="amount"
                    name="amount"
                    type="number"
                    labelText="Amount"
                    placeholder="Enter Amount"
                    value={formData.amount}
                    onChange={(e) => {
                      const amount = e.target.value;
                      if (
                        Number(amount) <=
                        Number(data?.data?.invoice?.balance_due)
                      ) {
                        setFormData({ amount });
                      }
                    }}
                  />
                </div>
                <Select
                  id="paymentMethod"
                  name="paymentMethod"
                  labelText="Payment Method"
                  className="mt-20"
                  onChange={(e) =>
                    setFormData({ paymentMethod: e.target.value })
                  }>
                  <SelectItem
                    selected={formData.paymentMethod === ''}
                    disabled
                    text="Select Payment Method"
                    value=""
                  />
                  <SelectItem
                    selected={formData.paymentMethod === 'MOBILE_MONEY'}
                    text="Mobile Money"
                    value="MOBILE_MONEY"
                  />
                  <SelectItem
                    selected={formData.paymentMethod === 'CARD'}
                    text="Card"
                    value="CARD"
                  />
                </Select>
              </>
            )}
          </div>
        </div>

        {error && <p className="text-14 mt-20 text-danger">{error.message}</p>}

        <div
          style={{
            marginTop: '100px',
            display: 'flex',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <CustomButton
            classes="outline danger no-border no-hover font-bold"
            style={{ flex: '1' }}
            disabled={isMutating}
            onClick={reset}>
            CLOSE
          </CustomButton>

          {!data && (
            <CustomButton
              type="submit"
              style={{ flex: '1' }}
              classes={`primary font-bold`}
              disabled={
                isMutating || !formData.invoiceNumber || !formData.emailAddress
              }
              onClick={(e) => {
                e.preventDefault();
                trigger();
              }}>
              {isMutating && (
                <div className="d-flex-center">
                  <Loading withOverlay={false} small={true} />
                  Verifying invoice number...
                </div>
              )}
              {!isMutating && 'VERIFY'}
            </CustomButton>
          )}
          {data && (
            <CustomButton
              type="submit"
              style={{ flex: '1' }}
              classes={`primary font-bold`}
              disabled={
                isMutating ||
                !formData.amount ||
                !formData.invoiceNumber ||
                !formData.emailAddress ||
                !formData.paymentMethod
              }
              onClick={(e) => {
                e.preventDefault();
                makePayment();
              }}>
              PAY
            </CustomButton>
          )}
        </div>
      </Form>
    </Modal>
  );
}
